import { ApolloLink } from '@apollo/client/core';
import cognitoLink from './cognitoLink';
import errorLink from './errorLink';
import httpLink from './httpLink';
const link = ApolloLink.from([errorLink, cognitoLink, httpLink]);
export default link;
